

// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import './Table.css';
// import { API_BASE_URL } from '../../config';

// export default function OrderApplication() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentAppID, setCurrentAppID] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/ViewApplication_DS.php`);
//         setApplications(response.data);
//       } catch (error) {
//         console.error('Error fetching applications:', error);
//       }
//     };

//     fetchApplications();
//   }, []);

  

//   const handleOpenModal = (app_ID) => {
//     setCurrentAppID(app_ID);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setCurrentAppID(null);
//   };

//   const handleClick = (app_ID, status) => {
//     // Update the status immediately in the local state
//     setApplications((prevApplications) =>
//       prevApplications.map((app) =>
//         app.app_ID === app_ID ? { ...app, Status: status } : app
//       )
//     );

//     // Send the update to the backend
//     axios
//       .post(`${API_BASE_URL}/UpdateOrderApplicationStatus.php`, { app_ID, status })
//       .then((response) => {
//         if (response.data.status !== 'success') {
//           console.error('Error updating status:', response.data.message);
//         }
//       })
//       .catch((error) => {
//         console.error('Error updating status:', error);
//       })
//       .finally(() => {
//         // Close the modal after status update
//         handleCloseModal();
//       });
//   };
//   const handleViewClick = async (app_ID) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
//         responseType: 'blob', // Expect binary data (PDF file)
//       });
  
//       // Create a Blob object and generate a download link
//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
//       link.click();
  
//       // Cleanup
//       URL.revokeObjectURL(link.href);
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//       alert('An error occurred while downloading the application.');
//     }
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Order Applications and View</h1>
      
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>View Grant (PDF)</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {applications.map((app) => (
//             <tr key={app.app_ID}>
//               <td>{app.app_ID}</td>
//               <td>{app.projectTitle}</td>
//               <td>{app.submittedDate}</td>
//               <td>
//                 <button
//                   className="view-button"
//                   onClick={() => handleViewClick(app.app_ID)} // Handle button click
//                 >
//                   View
//                 </button>
//               </td>
//               <td>
//                 {app.Status === '1' && (
//                   <button
//                     className="select-unselect-button"
//                     onClick={() => handleOpenModal(app.app_ID)}
//                   >
//                     Select
//                   </button>
//                 )}
//                 {app.Status === '2.1' && (
//                   <button
//                     className="Shortlisted-button"
//                     onClick={() => handleClick(app.app_ID, '2.1')}
//                   >
//                     Shortlisted
//                   </button>
//                 )}
//                 {app.Status === '2.2' && (
//                   <button
//                     className="Reject-button"
//                     onClick={() => handleClick(app.app_ID, '2.2')}
//                   >
//                     Rejected
//                   </button>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       {/* Modal */}
//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title className="modaltitle">Select Application Status</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Button variant="success" className='granted_deny'  onClick={() => handleClick(currentAppID, '2.1')}>
//             Shortlist
//           </Button>
//           <Button variant="danger" className='granted_deny' onClick={() => handleClick(currentAppID, '2.2')}>
//             Reject
//           </Button>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Table.css';
import { API_BASE_URL } from '../../config';

export default function OrderApplication() {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentAppID, setCurrentAppID] = useState(null);
  const [selectedYear, setSelectedYear] = useState("");
 
  const navigate = useNavigate();

  // Generate years from a starting year (e.g., 2010) to the current year
  const currentYear = new Date().getFullYear();
  const startYear = 2024; // Adjust this as needed
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse(); // Reverse to show latest years first

useEffect(() => {
  const fetchApplications = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewApplication_DS.php`);
      setApplications(response.data);
      if (selectedYear === "") {
        setFilteredApplications(response.data); // Show all applications
      } else {
        setFilteredApplications(
          response.data.filter((app) => {
            const appYear = new Date(app.submittedDate).getFullYear();
            return appYear === parseInt(selectedYear);
          })
        );
      }
    } catch (error) {
      console.error('Error fetching applications:', error);
    }
  };
  fetchApplications();
}, [selectedYear]);
  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value));
  };

  const handleOpenModal = (app_ID) => {
    setCurrentAppID(app_ID);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAppID(null);
  };

  const handleClick = (app_ID, status) => {
    // Update the status immediately in the local state
    setApplications((prevApplications) =>
      prevApplications.map((app) =>
        app.app_ID === app_ID ? { ...app, Status: status } : app
      )
    );
    setFilteredApplications((prevFiltered) =>
      prevFiltered.map((app) =>
        app.app_ID === app_ID ? { ...app, Status: status } : app
      )
    );

    // Send the update to the backend
    axios
      .post(`${API_BASE_URL}/UpdateOrderApplicationStatus.php`, { app_ID, status })
      .then((response) => {
        if (response.data.status !== 'success') {
          console.error('Error updating status:', response.data.message);
        }
      })
      .catch((error) => {
        console.error('Error updating status:', error);
      })
      .finally(() => {
        handleCloseModal();
      });
  };

  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = `Application_${app_ID}.pdf`;
      link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Order Applications and View</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={handleYearChange}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>View Grant (PDF)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.map((app) => (
            <tr key={app.app_ID}>
              <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
              <td>{app.projectTitle}</td>
              <td>{app.submittedDate}</td>
              <td>
                <button
                  className="view-button"
                  onClick={() => handleViewClick(app.app_ID)}
                >
                  View
                </button>
              </td>
              <td>
                {app.Status === '1' && (
                  <button
                    className="select-unselect-button"
                    onClick={() => handleOpenModal(app.app_ID)}
                  >
                    Select
                  </button>
                )}
                {app.Status === '2.1' && (
                  <button
                    className="Shortlisted-button"
                    onClick={() => handleClick(app.app_ID, '2.1')}
                  >
                    Shortlisted
                  </button>
                )}
                {app.Status === '2.2' && (
                  <button
                    className="Reject-button"
                    onClick={() => handleClick(app.app_ID, '2.2')}
                  >
                    Rejected
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">Select Application Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="success"
            className="granted_deny"
            onClick={() => handleClick(currentAppID, '2.1')}
          >
            Shortlist
          </Button>
          <Button
            variant="danger"
            className="granted_deny"
            onClick={() => handleClick(currentAppID, '2.2')}
          >
            Reject
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}